import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Nutzungsanalyse (utils/nutzung.js) hängt sich hier ein: Dauer + Status jeder Anfrage
let fetchBeobachter = null;
export function setFetchBeobachter(fn) { fetchBeobachter = fn; }

function beobachtetesFetch(input, init) {
    const start = performance.now();
    const url = typeof input === 'string' ? input : input?.url || String(input);
    const melden = (status, antwort) => {
        try { fetchBeobachter?.(url, init?.method, status, performance.now() - start, antwort); } catch { /* nie die Anfrage stören */ }
    };
    return fetch(input, init).then(
        (res) => {
            // Bei Fehlern die Antwort des Servers mitgeben (Kopie — das Original liest supabase-js)
            if (res.status >= 400 && fetchBeobachter) {
                res.clone().text().then((t) => melden(res.status, t), () => melden(res.status));
            } else {
                melden(res.status);
            }
            return res;
        },
        (err) => { melden(0); throw err; },
    );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, { global: { fetch: beobachtetesFetch } });

// Edge Function der KI. Lokal auf eine Testfassung umlenkbar (REACT_APP_AI_FUNCTION=ai-probe),
// ohne dass die Live-Function angefasst wird.
export const AI_FUNCTION = process.env.REACT_APP_AI_FUNCTION || 'ai';
